import { c as _c } from "react/compiler-runtime";
import { Folders, GitCompare, HeartPulse, Key, Lightbulb, LocateFixed, SmilePlus, Tags, TriangleAlert, Workflow } from 'lucide-react';
import React from 'react';
import { GroupByValue } from '@/types/groupBy';
export const GroupByChipIcon = t0 => {
  const $ = _c(11);
  const {
    value
  } = t0;
  if (value === "user_action") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Tags size={14} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (value === "user_intent") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Lightbulb size={14} />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (value === "negative_user_intent_v2") {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <TriangleAlert size={14} />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (value === "topic") {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Folders size={14} />;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  if (value === "keyword") {
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Key size={14} />;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  if (value === "interaction_label" || value === "conversation_label") {
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Tags size={14} />;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  if (value === "sentiment") {
    let t1;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SmilePlus size={14} />;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  if (value === "emotions") {
    let t1;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <HeartPulse size={14} />;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    return t1;
  }
  if (value === "data_source") {
    let t1;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <GitCompare size={14} />;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    return t1;
  }
  if (value?.startsWith("tag")) {
    let t1;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Workflow size={14} />;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    return t1;
  }
  let t1;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LocateFixed size={14} />;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
};